export default {"src":"/_next/static/media/assistant-bank.7da9d5f9.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};